import { all, call, put, takeLatest } from 'redux-saga/effects';
import qs from 'qs';
import envConfig from '../../../config';
import {
  getPartialPipelinesList,
  getPartialCustomObjectInstanceList,
} from '../../routines';

import { request } from '../../../common/util/RestClient';
import { sortEntityByActivityStatus } from '../../../common/util/EntityUtils';
import { CUSTOM_OBJECT_BASE_PATH } from '../../../common/constants/CustomObjectConstants';

export function* getPipelinesPartialList(payload) {
  const { name, mandatoryIds } = payload;
  try {
    let URL = `${envConfig.APIG_URL}core/pipelines/partial`;
    const params = {};
    if (name && name.trim() !== '') {
      params.name = name;
    }
    if (mandatoryIds && mandatoryIds.length > 0) {
      params.mandatoryIds = mandatoryIds.join(',');
    }

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialPipelinesList.success({
        data: sortEntityByActivityStatus(response.data),
      })
    );
  } catch (error) {
    yield put(getPartialPipelinesList.failure({ error }));
  }
}

export function* getCustomObjectInstancePartialList({ payload }) {
  const { name, mandatoryIds, apiName } = payload;
  try {
    let URL = `${envConfig.APIG_URL}${CUSTOM_OBJECT_BASE_PATH}/instance/${apiName}/partial`;
    const params = {};
    if (name && name.trim() !== '') {
      params.name = name;
    }
    if (mandatoryIds && mandatoryIds.length > 0) {
      params.mandatoryIds = mandatoryIds.join(',');
    }

    const queryString = qs.stringify(params);
    if (queryString) {
      URL = `${URL}?${queryString}`;
    }
    const response = yield call(request, URL);
    yield put(
      getPartialCustomObjectInstanceList.success({
        data: sortEntityByActivityStatus(response.data),
        level: apiName,
      })
    );
  } catch (error) {
    yield put(getPartialCustomObjectInstanceList.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(getPartialPipelinesList.TRIGGER, getPipelinesPartialList),
    takeLatest(
      getPartialCustomObjectInstanceList.TRIGGER,
      getCustomObjectInstancePartialList
    ),
  ]);
}
